
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import abstract from "@/store/abstract/actions";

export default defineComponent({
  setup() {
    const loading = ref(true);
    const notFound = ref(false);
    const notSupport = ref(false);
    const loadingApply = ref(true);
    const validApply = ref(true);
    const pdfURL = ref("");
    const store = useStore();
    const router = useRouter();
    const eventData = computed(() => store.getters["user/eventData"]);
    const participantData = computed(
      () => store.getters["user/participantData"]
    );
    const validApplyAbstract = async (data) => {
      validApply.value = await abstract.validAbstractApply(data);
      loadingApply.value = false;
    };
    watch(eventData, (newValue, lastValue) => {
      if (newValue != lastValue) {
        if (eventData.value.abstractSettings) {
          const url = eventData.value.abstractSettings.abstractImage;
          pdfURL.value = encodeURIComponent(url);
        } else notFound.value = true;
        loading.value = false;
      }
    });
    store.dispatch("user/getFeaturesAccess", "abstracts");
    onMounted(() => {
      if (eventData.value) {
        validApplyAbstract({
          eventID: eventData.value.id,
          uid: participantData.value.uid,
        });
        if (eventData.value.abstractSettings) {
          const url = eventData.value.abstractSettings.abstractImage;
          pdfURL.value = encodeURIComponent(url);
        } else notFound.value = true;
        loading.value = false;
      }
    });
    const goTo = () => {
      router.push({
        name: "UploadAbstract",
        params: { eventID: eventData.value.id },
      });
    };
    return {
      eventData,
      loading,
      notFound,
      loadingApply,
      validApply,
      goTo,
      notSupport,
      pdfURL,
    };
  },
});
